function msToTime(duration) {
  var seconds = Math.floor((duration / 1000) % 60),
    minutes = Math.floor((duration / (1000 * 60)) % 60),
    hours = Math.floor((duration / (1000 * 60 * 60)))

  hours = (hours < 10) ? "0" + hours : hours
  minutes = (minutes < 10) ? "0" + minutes : minutes
  seconds = (seconds < 10) ? "0" + seconds : seconds

  return hours + ":" + minutes + ":" + seconds
}

/** Formats an input (in seconds) to be human-friendly. */
function niceTime(seconds) {
  let s = Math.floor(seconds % 60),
    m = Math.floor((seconds / 60) % 60),
    h = Math.floor((seconds / 3600) % 24),
    d = Math.floor((seconds / 86400));

  let string = "";
  if (d > 0) string += d + "d ";
  if (h > 0) string += h + "h ";
  string += m + "m ";
  if (d == 0) string += s + "s";

  return string.trim();
}

export { msToTime, niceTime }
